module.exports = __webpack_public_path__ + "img/profitbg.0c79a939.png";